import React from "react";
import { Spinner } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { faDog, faUsers } from "@fortawesome/free-solid-svg-icons";
import CardInfo from "src/components/Cards/Info";
import StatChart from "src/components/StatChart";
import GuestsOriginsChart from "./GuestsOriginsChart";

const GuestsStats = ({ stats }) => {
  const { t } = useTranslation("dashboard");
  const ageGroupDistributionChart = stats?.statCharts?.find(
    (chart) => chart.type === "age_group_distribution"
  );
  const otherCharts = stats?.statCharts?.filter(
    (chart) => chart.type !== "age_group_distribution"
  );

  if (stats === null) {
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ height: "60vh" }}
      >
        <Spinner animation="border" variant="primary" role="status">
          <span className="sr-only">Lade...</span>
        </Spinner>
      </div>
    );
  }

  return (
    <>
      {/* NUMBERS */}
      <h2 className="h6 text-muted">{t("stats.current_metrics")}</h2>
      <div className="row">
        <CardInfo
          title="Gäste aktuell"
          icon={faUsers}
          color="warning"
          value={stats.guests_today}
          hint={`Gestern: ${stats.guests_yesterday}`}
          infoId="current-guests"
          description="Gäste aktuell anhand des Check-in- und Check-out-Datums."
        />
        <CardInfo
          title="Hunde pro Jahr"
          icon={faDog}
          color="info"
          value={`${stats.dogs_per_year}`}
          hint={`Letztes Jahr: ${stats.dogs_last_year}`}
          infoId="dogs-per-year"
          description={t("stats.dogs_per_year.description")}
        />
      </div>

      {/* CHARTS */}
      <div className="w-100">
        {otherCharts.map((statChart) => (
          <StatChart key={statChart.type} statChart={statChart} />
        ))}

        {ageGroupDistributionChart?.data?.labels?.length > 0 && (
          <StatChart statChart={ageGroupDistributionChart} />
        )}
      </div>

      <GuestsOriginsChart stats={stats} />
    </>
  );
};

export default GuestsStats;
